export default __webpack_public_path__ + "web/react/components/app-download-promo/image-assets/XL_DESKTOP.b903aca22358854a1cd074ab1f1d0276.jpg";